import React, { useMemo } from 'react';
import { ProjectType } from 'nekst-api';
import { useTeamSetupAreaContextRequired } from './TeamSetupAreaContext';
import InnerBlock from '../../shared/web/layout/InnerBlock';
import { Header3, NewLine, SimpleBlock, Text } from 'ui-builder';
import { CopyValueToClipboard, TimezoneDisplay } from 'features/nekst-widgets';
import { useProjectTypeHelper } from 'features/tasks-forms';
import { MarketTimezoneToggleWrapper } from 'feature-toggle';


function AliasWidget() {
  const { teamSetupArea } = useTeamSetupAreaContextRequired();

  return (
    <>
      <Text bold>Alias:</Text> {teamSetupArea.alias} <CopyValueToClipboard text={teamSetupArea.alias} />
    </>
  )
}

function TypeWidget() {
  const { teamSetupArea } = useTeamSetupAreaContextRequired();

  const projectTypeHelper = useProjectTypeHelper();

  const label = useMemo(() => {
    if (teamSetupArea.isCustom && teamSetupArea.projectType) {
      return projectTypeHelper.getLabel(teamSetupArea.projectType)
    } else {
      return null;
    }
  }, [teamSetupArea.projectType]);

  if (label) {
    return (
      <>
        <Text bold>Type:</Text> {label}
      </>
    )
  } else {
    return null;
  }

}

function TimezoneWidget() {
  const { teamSetupArea } = useTeamSetupAreaContextRequired();

  if (teamSetupArea.timezone) {
    return (
      <MarketTimezoneToggleWrapper>
        <TimezoneDisplay value={teamSetupArea.timezone} label="Timezone" />
      </MarketTimezoneToggleWrapper>
    );
  } else {
    return null;
  }
}


export function TeamSetupAreaInnerBlock(
  props: {
    children: React.ReactNode,
    projectType: ProjectType,
    headerRight?: React.ReactNode,
  }
) {
  const { teamSetupArea } = useTeamSetupAreaContextRequired();


  return (
    <InnerBlock
      title={`${teamSetupArea.name}`}
      titleLine2={(
        <SimpleBlock>
          <AliasWidget />
          <NewLine />
          <TimezoneWidget />
          <NewLine />
          <TypeWidget />
        </SimpleBlock>
      )}
      headerRight={props.headerRight}
    >
      <Header3>Detail Boxes</Header3>
      {props.children}
    </InnerBlock>
  );
}
